import { IconX } from 'components/Generic/Icons/IconX';
import { useI18n } from 'next-localization';
import styles from './ModalHeader.module.scss';
import { FC } from 'react';

export const ModalHeader: FC<{ title: string; onClose?: () => void }> = ({ title, onClose }) => {
  const { t } = useI18n();
  return (
    <div
      className={`d-flex align-items-center justify-content-between p-2 p-md-4 ${styles['modal-heading']}`}
    >
      <h3 className="subheader-1">{title}</h3>
      <button className="btn btn-naked text-link" onClick={onClose}>
        {t('close')} <IconX className={`ms-1 ${styles['icon-close']}`} />
      </button>
    </div>
  );
};
